module.exports = "<div class=\"text-center\">\n    <img class=\"img-thumbnail rounded-circle\" src='https://ru.gravatar.com/userimage/17702696/3895c416ee56759755edd2e23d4ee294.jpg?size=200'/>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/articles/title.md
// module id = 6IIv
// module chunks = 1